module.exports = __webpack_public_path__ + "8f219a12c614a4fee90c8c6d5a5bd721.png";